import React from 'react';

import { useNotification } from 'src/hooks/app';

import type { EmployeeInviteLinkArgs } from './useCopyEmployeeInviteLink';
import type { ResendInviteScope } from './useResendEmployeeInvite';
import { useScopedInviteMutation } from './useScopedInviteMutation';

type UseSendEmployeeInviteParams = {
  successMessage?: string;
};

export const useSendEmployeeInvite = (
  scope: ResendInviteScope,
  params: UseSendEmployeeInviteParams = {},
) => {
  const { createApolloContext } = useNotification();
  const context = createApolloContext({
    errorMessage: 'Failed to send the invite',
    successMessage: params.successMessage ?? 'Invite sent',
  });

  const mutate = useScopedInviteMutation(scope, context);

  return React.useCallback(
    async (
      employeeId: string,
      inviteLinkArgs?: EmployeeInviteLinkArgs | null,
      inviteEmail?: string,
    ) => {
      await mutate({
        variables: {
          employeeIds: [employeeId],
          inviteScopeEntityId: scope === 'cvStaff' ? inviteLinkArgs?.entityId : undefined,
          inviteScopeParamKey: scope === 'cvStaff' ? inviteLinkArgs?.paramKey : undefined,
          inviteEmail,
        },
      });
    },
    [scope, mutate],
  );
};
